module.exports = __webpack_public_path__ + "assets/img/erweima.db553f45.png";